import { render, staticRenderFns } from "./SkewGreyContainer.vue?vue&type=template&id=8512089e&scoped=true&"
import script from "./SkewGreyContainer.vue?vue&type=script&lang=js&"
export * from "./SkewGreyContainer.vue?vue&type=script&lang=js&"
import style0 from "./SkewGreyContainer.vue?vue&type=style&index=0&id=8512089e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8512089e",
  null
  
)

export default component.exports